module.exports = __webpack_public_path__ + "img/calender_empty.6ba867ed.svg";